import { Reveal, Chapter } from "./Reveal";
import { BadgeCheck, ShieldCheck, ClipboardList, SearchCheck, FileText, Route } from "lucide-react";
import { useT } from "../i18n";

const ICONS = [BadgeCheck, ShieldCheck, ClipboardList, SearchCheck, FileText, Route];

const Quality = () => {
  const t = useT();
  return (
    <section id="quality" data-testid="quality-section" className="bg-[#0B0E14] py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Chapter number="05" label={t.quality.label} testid="quality-chapter" />
        </Reveal>
        <div className="mt-8 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <Reveal delay={0.1}>
            <h2 className="font-display text-3xl font-semibold uppercase leading-tight tracking-wide text-white sm:text-4xl">
              {t.quality.title}
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="max-w-xl text-sm leading-relaxed text-slate-400">{t.quality.sub}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px bg-slate-800/60 sm:grid-cols-2 lg:grid-cols-3">
          {t.quality.cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={card.t} delay={0.06 * i}>
                <div
                  data-testid={`quality-card-${i + 1}`}
                  className="group h-full bg-[#0B0E14] p-8 transition-[background-color] duration-500 hover:bg-[#111D38]"
                >
                  <div className="flex items-start justify-between">
                    <Icon size={26} strokeWidth={1.5} className="text-gold transition-transform duration-500 group-hover:-translate-y-1" />
                    <span className="font-mono text-[10px] tracking-[0.3em] text-slate-600">0{i + 1}</span>
                  </div>
                  <h3 className="mt-6 text-base font-semibold text-slate-100">{card.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{card.x}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.3}>
          <p className="mt-8 font-mono text-[10px] tracking-[0.18em] text-slate-500">{t.quality.note.toUpperCase()}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default Quality;
